import React from "react";

interface Props {
	color?: string;
	className?: string;
	removeOutline?: boolean;
}

export const MicrosoftLogo = ({ color, className, removeOutline = true }: Props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 23 23"
		className={`${className} svg-microsoft-logo`}
	>
		<style>{`.svg-microsoft-logo path + path{fill:${color};}`}</style>
		<path fill={removeOutline ? "transparent" : "#f3f3f3"} d="M0 0h23v23H0z" />
		<path fill="#f35325" d="M1 1h10v10H1z" />
		<path fill="#81bc06" d="M12 1h10v10H12z" />
		<path fill="#05a6f0" d="M1 12h10v10H1z" />
		<path fill="#ffba08" d="M12 12h10v10H12z" />
	</svg>
);
